import { render } from "./configmap.vue?vue&type=template&id=e5d390d2&scoped=true"
import script from "./configmap.vue?vue&type=script&lang=js"
export * from "./configmap.vue?vue&type=script&lang=js"

import "./configmap.vue?vue&type=style&index=0&id=e5d390d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d390d2"]])

export default __exports__